import { createContext } from 'react';
import { IEnterpriseProfileStructureJSON } from '../../../../../../interfaces/enterprise-profile/enterprise.interface';

const EnterpriseProfileStructureContext =
  createContext<IEnterpriseProfileStructureJSON>({
    structure: [],
  });

export default EnterpriseProfileStructureContext;
